/**
 * Save Gmail Application Attachments To FTP
 * APi specification to save application attachments received in gmail to FTP
 *
 * OpenAPI spec version: 1.0.0
 * Contact: jimmy.nsenga@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export type Status = 'created' | 'ongoing' | 'done' | 'cancelled';

export const Status = {
    Created: 'created' as Status,
    Ongoing: 'ongoing' as Status,
    Done: 'done' as Status,
    Cancelled: 'cancelled' as Status
};
